<!-- State/Store Builder -->

<template>
	<div class="bld-state-main">
		<div class="title wi8_font">State/Store Builder</div>

			count = {{ count }} <br/>

			<button @click="goIncrement">Increment</button>
			<button @click="goShowState">Show State</button>
			<button @click="goTest">Test</button>

	</div>
</template>

<script>
import { m } from "@/utils/utils";
import { mapState } from 'vuex';
export default {
	computed: {
		...mapState('usr', ['count']),
		// ...mapState('pub', ['count']),
	 },
	 methods: {
		 goTest() {
			m("test word: " + this.ugenWord(6));
			const dat = {"name":"Steve", "city":"Chicago", "zip":"60606"};
			m("hey");
			m(dat);
			m("dat", dat);
		 },
		 goShowState() {
			m("go show state");
			let apiState = this.$store.getters["api/state"];
			let appState = this.$store.getters["app/state"];
			let pubState = this.$store.getters["pub/state"];
			let usrState = this.$store.getters["usr/state"];
			m("apiState", apiState);
			m("appState", appState);
			m("pubState", pubState);
			m("usrState", usrState);
		 },
		 goIncrement() {
			 m("go increment");
			 this.$store.dispatch('usr/incrementCount', 1);
		 }
	 }
}
</script>

<style scoped>
	.bld-state-main {
		height: 100%;
		background-color: #FCFCEE;
		padding: 5px;
		border: solid 0px #009;
	}
	.title {
		color: #F63;
	}
</style>
